
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'

@Component
export default class BarChart extends Vue {
  @Prop() data!: any

  optionsDefault = {
    chart: {
      type: 'bar',
      background: 'transparent'
    },
    plotOptions: {
      bar: {
        horizontal: false
      }
    },
    dataLabels: {
      enabled: false
    },
    fill: {
      opacity: 1
    },
    tooltip: {
    }
  };

  themeMode= 'light'

  created () {
    this.onThemeChange(this.$vuetify.theme.dark)
  }

  get options () {
    return { ...this.optionsDefault, xaxis: this.data.xaxis, theme: { mode: this.themeMode }, tooltip: { theme: this.themeMode } }
  }

  @Watch('$vuetify.theme.dark')
  onThemeChange (dark: boolean) {
    this.themeMode = dark ? 'dark' : 'light'
  }
}
